import navItem from "./navItem";

export default function setNavigation() {
    $('.home #post_inhalt .bereich').each(function () {
        const bereich = $(this);
        const ank = bereich.attr('id');
        const label = bereich.attr('data-bezeichung');
        $('#main-nav').append(navItem({ ank: ank, label: label }));
    });
    let label = 'Kontakt';
    if ($('html').attr('lang') != 'de-DE') {
        label = 'Contact';
    }
    $('#main-nav').append(navItem({ ank: 'kontakt', label: label }));
    $('.nav .nav_toggle').on('click', function (e) {
        e.preventDefault();
        $('.main_navigation').toggle();
    });
}